export enum CodeLanguage {
	UNKNOWN = 'unknown',
	GL = 'gl',
	JS = 'js',
}
export enum CodeDisplayer {
	UNKNOWN = 'unknown',
	FRAGMENT_ONLY = 'fragmentOnly',
	VERTEX_AND_FRAGMENT = 'vertexAndFragment',
	MULTI = 'multi',
	ACTOR = 'actor',
	ACTOR_VELOCITY_COLLIDER = 'actorVelocityCollider',
}
export interface CodeData {
	language: CodeLanguage;
	displayer: CodeDisplayer;
}
